import React from "react";
import ReactDOM from "react-dom/client";
import { LanguageProvider } from './contexts/LanguageContext';
import App from "./App";
import "./styles.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>
);
